// extracted by mini-css-extract-plugin
export var cls1 = "BlancaSvg-module--cls-1--tqaIl";